<div class="date-container">
  <ul class="date-list">
    @for (item of siteAdvertDays; track item) {
      <li
        (click)="selectDate(item.pubDate, item.soldOut, item.UserObj)"
      [ngClass]="{
        'sold-out': item.soldOut, 
        'isCommonUser': item.UserObj === 'free',  
        'memberUser': item.UserObj === 'member', 
        'move': move, 
        'selected': item.selected
      }"
        >
        <span>{{moment(item.pubDate, 'YYYYMMDD').format('ddd, MMM D, YYYY')}}</span>
        @if (item.soldOut) {
          <span> - SOLD OUT</span>
        }
        @if (item.UserObj === 'free') {
          <span> (Gold and Platinum only)</span>
        }
        @if (item.UserObj === 'member') {
          <span> (early access for you)</span>
        }
        <!-- <span *ngIf="item.isMember"> - MEMBERS ONLY</span> -->
      </li>
    }
  </ul>
</div>
